export const EXTRATO_LOADING = 'EXTRATO_LOADING';
export const EXTRATO_RESUMO_ADMINISTRADOR = 'EXTRATO_RESUMO_ADMINISTRADOR';
export const EXTRATO_RESUMO_USUARIO = 'EXTRATO_RESUMO_USUARIO';
export const EXTRATO_RESUMO_USUARIO_MES_ANTERIOR = 'EXTRATO_RESUMO_USUARIO_MES_ANTERIOR';
export const EXTRATO_FATURA_DETALHADA = 'EXTRATO_FATURA_DETALHADA';
export const EXTRATO_FATURA_ASSINATURA = 'EXTRATO_FATURA_ASSINATURA';
